import React, { useState } from 'react';
import ProfilePreview from './ProfilePreview';
import Styles from "../Styles/Profile.module.css";
import add from "../Assets/add.png";
import { Button } from '@mui/material';


const Header = () => {
  const [name, setName] = useState('Your Name');
  const [images, setImages] = useState([]);
  const [previewMode, setPreviewMode] = useState(false);
  const [profileData, setProfileData] = useState({});
  const [jobType, setJobType] = useState({
    Contract: "contract",
    Remote:"remote",

  });
 

  const [contactInfo, setContactInfo] = useState({
    FirstName: 'First Name',
    LastName: 'Last Name',
    Headline: 'HeadLines',
    EmailAddress: 'Email Address',
    Date: 'Date of Birth',
    ContactNumber: 'Your Number'
  });
  
  const [location, setLocation] = useState({
    address: 'Your Address',
    city: 'Your City',
    state: 'Your State',
    zip: 'Your Zip Code'
  });
  const [url, setUrl] = useState({
    linkedln: 'Linkeddln',
    Behance: 'Behance',
    Github: 'Github',
    Twitter: 'Twitter'
  });
  const [experience, setExperience] = useState({
    company: 'company',
    jobtitle: 'jobtitle',
   
  });
  const [salary, setSalary] = useState({
    Annually: 'Annually',
    
   
  });
  const [project, setProject] = useState({
    Url: 'Url',
    
   
  });
  const [skill, setSkill] = useState({
    React: 'React',
    
   
  });
  const [letter, setLetter] = useState({
    Cover: '',
    
   
  });

  const [education, setEducation] = useState({
    School: 'School',
    city: 'City,State',
    Education: 'Level of education (i.e BSc, BEng, BArt, Hnd)',
    FieldOfStudy: 'Field Of Study'
  });
  

  
  const handleContactInfoChange = (event) => {
    const { name, value } = event.target;
    setContactInfo((prevState) => ({ ...prevState, [name]: value }));
  };
  
  const handleLocationChange = (event) => {
    const { name, value } = event.target;
    setLocation((prevState) => ({ ...prevState, [name]: value }));
  };
  const handleEducationChange = (event) => {
    const { name, value } = event.target;
    setEducation((prevState) => ({ ...prevState, [name]: value }));
  };
  const handleExperienceChange = (event) => {
    const { name, value } = event.target;
    setExperience((prevState) => ({ ...prevState, [name]: value }));
  };
  const handleSalaryChange = (event) => {
    const { name, value } = event.target;
    setSalary((prevState) => ({ ...prevState, [name]: value }));
    
  };
  const handleLetterChange = (event) => {
    const { name, value } = event.target;
    setLetter((prevState) => ({ ...prevState, [name]: value }));
  };
  const handleProjectChange = (event) => {
    const { name, value } = event.target;
    setProject((prevState) => ({ ...prevState, [name]: value }));
  };
  const handleSkillChange = (event) => {
    const { name, value } = event.target;
    setSkill((prevState) => ({ ...prevState, [name]: value }));
  };
  const handleUrlChange = (event) => {
    const { name, value } = event.target;
    setUrl((prevState) => ({ ...prevState, [name]: value }));
  };



  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleAddImage = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      setImages([...images, event.target.result]);
    };

    reader.readAsDataURL(file);
  };

  const handleRemoveImage = (index) => {
    setImages([...images.slice(0, index), ...images.slice(index + 1)]);
  };

  const handleSave = () => {
    const profileData = { name, images ,contactInfo, location , jobType , education , experience , salary , letter};
    setProfileData(profileData);
    console.log(profileData)
    setPreviewMode(true);
  };

  const handleEdit = () => {
    setPreviewMode(false);
  };

  if (previewMode) {
    return <ProfilePreview profileData={profileData} onEdit={handleEdit} />;
  }

  return (
    <div className={Styles.headercontainer}>
      <div className={Styles.textwrapper}>
        <h1>
          <input type="text" id={Styles.nameinput} value={name} onChange={handleNameChange} />
        </h1>
      </div>
      <p>Profile Photo</p>
      <div className={Styles.Profilecontainer}>
        <div className={Styles.imagecontainer}>
          {images.length > 0 && (
            <div className={Styles.circlecontainer}>
              <img src={images[0]} alt={`Profile `} className={Styles.Previewimage} />
            </div>
          )}
        </div>
        <div className={Styles.imageupload}>
          <div className={Styles.Addimage}>
            <input type="file" id={Styles.fileinput} onChange={handleAddImage} />
            <label htmlFor="file-input" className={Styles.labelinput}>
              Upload Photo
            </label>
            <button disabled={!images.length} onClick={() => handleRemoveImage(0)}>Remove</button>
          </div>
          
        </div>
      </div>  
     <div className={Styles.contactinfo}>
  <p>Contact Information</p>
  <div className={Styles.forminfo} >
  <input type="text" name="FirstName" value={contactInfo.FirstName} onChange={handleContactInfoChange} />
  <input type="text" name="LastName" value={contactInfo.LastName} onChange={handleContactInfoChange} />
  <input type="text" name="Headline" value={contactInfo.Headline} onChange={handleContactInfoChange} />
  <input type="text" name="EmailAddress" value={contactInfo.EmailAddress} onChange={handleContactInfoChange} />
  <input type="text" name="Date" value={contactInfo.Date} onChange={handleContactInfoChange} />
  <input type="text" name="ContactNumber" value={contactInfo.ContactNumber} onChange={handleContactInfoChange} />
  </div>
</div>

<div className={Styles.location}>
  <p>Location</p>
  <span>This helps match you with nearby jobs.</span>
  <div className={Styles.locationinfo} >
  <input type="text" name="address" value={location.address} onChange={handleLocationChange} />
  <input type="text" name="city" value={location.city} onChange={handleLocationChange} />
  <input type="text" name="state" value={location.state} onChange={handleLocationChange} />
  <input type="text" name="zip" value={location.zip} onChange={handleLocationChange} />
</div>
</div>
<div className={Styles.jobtype}>
  <p>Type of job</p>
<div className={Styles.typecontainer}>
    <input type="checkbox" name="jobType" value={jobType.Contract} checked={jobType === "contract"} onChange={(e) => setJobType(e.target.value)} className={Styles.squareradio} />
    <label> Contract</label>
 
    <input type="checkbox" name="jobType" value={jobType.Remote} checked={jobType === "remote"} onChange={(e) => setJobType(e.target.value)} className={Styles.squareradio} />
    <label style={{ whiteSpace:"nowrap" , position:"relative" , left:"26px", bottom:"25px"}}> Fulltime employment</label>
  </div>
</div>
<div className={Styles.education}>
  <p>Education</p>
  <div className={Styles.educationinfo} >
  <input type="text" name="School" value={education.School} onChange={handleEducationChange} />
  <input type="text" name="city" value={education.city} onChange={handleEducationChange} />
  <input type="text" name="Education" value={education.Education} onChange={handleEducationChange} />
  <input type="text" name="FieldOfStudy"  value={education.FieldOfStudy} onChange={handleEducationChange} />
</div>
<div className={Styles.addinfo}>
<img src={add} alt="/" width="20.0px" height="20.0px" />
 <span>Add new</span>
</div>
</div>
<div className={Styles.experience}>
  <p>Work Experience</p>
  <div className={Styles.experienceinfo} >
  <input type="text" name="company" value={experience.company} onChange={handleExperienceChange} />
  <input type="text" name="jobtitle" value={experience.jobtitle} onChange={handleExperienceChange} />
</div>
<div className={Styles.addinfo}>
<img src={add} alt="/" width="20.0px" height="20.0px" />
 <span>Add new</span>
</div>
</div>
<div className={Styles.salary}>
  <p>Salary expectation</p>
  <div className={Styles.salaryinfo} >
  <input type="text" name="Annually" value={salary.Annually} onChange={handleSalaryChange} /> 
</div>
</div>
<div className={Styles.letter}>
  <p>Cover Letter</p>
  <div className={Styles.letterinfo} >
  <textarea type="text" name="Cover" value={letter.Cover} onChange={handleLetterChange} /> 
</div>
</div>
<div className={Styles.project}>
  <p>Add a Project  <svg width="5" height="10" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ position:'relative', bottom:"3px"}}>
<path d="M3.75 0C3.0625 0 2.5 0.5625 2.5 1.25C2.5 1.9375 3.0625 2.5 3.75 2.5C4.4375 2.5 5 1.9375 5 1.25C5 0.5625 4.4375 0 3.75 0ZM1.875 3.125C0.8375 3.125 0 3.9625 0 5H1.25C1.25 4.65 1.525 4.375 1.875 4.375C2.225 4.375 2.5 4.65 2.5 5C2.5 5.35 1.25 7.05 1.25 8.125C1.25 9.2 2.0875 10 3.125 10C4.1625 10 5 9.1625 5 8.125H3.75C3.75 8.475 3.475 8.75 3.125 8.75C2.775 8.75 2.5 8.475 2.5 8.125C2.5 7.675 3.75 5.825 3.75 5C3.75 3.9875 2.9125 3.125 1.875 3.125Z" fill="black"/>
</svg></p>
 

  <div className={Styles.projectinfo} >
  <input type="text" name="Url" value={project.Url} onChange={handleProjectChange} /> 
</div>
<div className={Styles.addinfo}>
<img src={add} alt="/" width="20.0px" height="20.0px" />
 <span>Add new</span>
</div>
</div>
<div className={Styles.skill}>
  <p>Add Skill</p>
  <div className={Styles.skillinfo} >
  <input type="text" name="React" value={skill.React} onChange={handleSkillChange} /> 
</div>
<div className={Styles.subcontent1}>
                    <Button sx={{ width: "80.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}>React</Button>
                    <Button sx={{ width: "80.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}>Javascript</Button>
                    <Button sx={{ width: "80.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}>React</Button>
                    <Button sx={{ width: "80.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}>Javascript</Button>
                    <Button sx={{ width: "80.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}>Javascript</Button>
                    <Button sx={{ width: "80.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}>HTML</Button>
                    <Button sx={{ width: "80.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}>CSS</Button>
                    <Button sx={{ width: "80.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}>CSS</Button>
   </div>
<div className={Styles.addinfo}>
<img src={add} alt="/" width="20.0px" height="20.0px" />
 <span>Add new</span>
</div>
</div>
<div className={Styles.urlinfo}>
  <p>Profile URL</p>
  <div className={Styles.forminfo} >
  <input type="text" name="linkedln" value={url.linkedln} onChange={handleUrlChange} />
  <input type="text" name="Behance" value={url.Behance} onChange={handleUrlChange} />
  <input type="text" name="Github" value={url.Github} onChange={handleUrlChange} />
  <input type="text" name="Twitter" value={url.Twitter} onChange={handleUrlChange} />

  </div>
  <button onClick={handleSave}>Save</button>
</div>

    </div>
  );
};

export default Header;
